import type { ResolverTag } from '@ps/web-core-enums';
import type { Page } from '@ps/web-core-store';
import { Translation, useResolver } from '@ps/web-shared-components';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import URL from 'url-parse';

import { CMSPage } from '@swf/cms';
import LoadingIndicator from '@swf/components/LoadingIndicator/LoadingIndicator';
import useRequest from '@swf/core/hooks/useRequest';
import type { PageResponse } from '@swf/core/models/cms';
import type { Dispatch, RootState } from '@swf/core/store';
import { select } from '@swf/core/store';

import { TXTMOB_Something_went_wrongX_Please_t_ELL } from './ResolverCMSContent.messages.json';
import styles from './ResolverCMSContent.scss';

interface Props {
  tag?: ResolverTag;
  pathname?: string;
}

const ResolverCMSContent: React.FC<Props> = ({ tag, pathname }) => {
  const url = useResolver(tag);
  const request = useRequest();
  const strippedPathname = useSelector((rootState: RootState) =>
    select.location.stripPrefix(rootState, new URL(url).pathname)
  );
  const [cmsPage, setCmsPage] = useState<Page>();
  const [error, setError] = useState(false);
  const {
    cms: { updateContent }
  } = useDispatch<Dispatch>();

  useEffect(() => {
    if (!url && !pathname) return;
    const path = pathname || strippedPathname;
    request<PageResponse>({ service: 'cms.page', body: { path } }).subscribe(({ body }) => {
      const { content, page } = body;
      updateContent(content);
      setCmsPage(page);
    }, setError);
  }, [url, request, pathname, strippedPathname, updateContent]);

  return (
    <LoadingIndicator loading={!cmsPage} className={styles.loading}>
      {error || !cmsPage ? (
        <div className={styles.error}>
          <Translation tagName="p" {...TXTMOB_Something_went_wrongX_Please_t_ELL} />
        </div>
      ) : (
        <CMSPage {...cmsPage} />
      )}
    </LoadingIndicator>
  );
};

export default ResolverCMSContent;
